import IPage from "../../../interfaces/page";
import ReesetPasswordFormComponent from "../../Components/ResetPasswordFrom/ResetPasswordForm.component";
import PublicLayout from "../../layouts/Public/Public.layout";

const ResetPasswordPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <PublicLayout component={ReesetPasswordFormComponent} />
}

export default ResetPasswordPage;